import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { isTablet, isWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    datePickerContainer: {
        flex: 1,
        borderRightWidth: 2,
    },
    datePickerButtonContainer: {
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: COLOR.background,
        paddingHorizontal: isTablet || isWeb ? 8 : 4,
    },
    svgArrowContainer: {
        height: '100%',
        marginRight: 4,
        justifyContent: 'center',
    },
    svgArrowListContainer: {
        marginLeft: 4,
    },
});

export default styles;
